import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, Subscription, forkJoin } from 'rxjs';
import * as moment from 'moment';
import { confirm } from 'devextreme/ui/dialog';
import { GridExpenseComponent } from '../../../../../shared/components/grid-expense/grid-expense.component';
import { LanguageService } from '../../../../../shared/services/language.service';
import { AmsNotifierService } from '../../../../../shared/services/ams-notifier.service';
import { TimeService } from '../../../../time/_api/services/time.service';

@Component({
  selector: 'app-project-portal-list-detail-expense',
  templateUrl: './project-portal-list-detail-expense.component.html',
  styleUrls: ['./project-portal-list-detail-expense.component.css']
})
export class ProjectPortalListDetailExpenseComponent implements OnInit, AfterViewInit {

  @ViewChild(GridExpenseComponent, {static:false}) private expenseGrid: GridExpenseComponent;

  @Input() showOnlyConfirmed: boolean = false;
  @Input() employeesNotQuit: any[];
  @Input() expenseTypeDataSource: any[];
  @Input() showTransportColumn: boolean = false;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(employee-portal.component) to show load indicator
  @Output() cellPrepared = new EventEmitter<any>();
  @Output() editingStart = new EventEmitter<any>();
  @Output() showExpenseGrid = new EventEmitter<boolean>();//emit event to parent(employee-portal.component) to show load indicator

  private eventsSubscription: Subscription;
  @Input() dateChangedEvent: Observable<any>;

  gridColumns: any;
  gridRecords: any;
  setSelectedDateRangeIndexExpense: number = 0;//index in app-date-selector
  selectedDateRangeIndexExpense: number = 0;//index in app-date-selector
  initDateExpense: any;
  fromExpense: string;
  toExpense: string;
  projectIds: any[];
  categoriesToApprove = [8,9];

  // initDate: any;
  from: string;
  to: string;
  setSelectedDateRangeIndex: number = 0;//index in app-date-selector
  selectedDateRangeIndex: number = 0;//index in app-date-selector

  searchParameters = {
    EmployeeIds: [],
    FromDate: "",
    ToDate: "",
    CategoryStatusCombos: [],
    ProjectIds: [],
  }

  approvalFunction = 2;

  constructor(private languageService: LanguageService,
              private amsNotifierService: AmsNotifierService, private timeService: TimeService) { }

  ngOnInit() {
    this.eventsSubscription = this.dateChangedEvent.subscribe((dateInterval) => this.dateChanged(dateInterval));
    this.from = moment().format("DD.MM.YYYY");
    this.to = moment().format("DD.MM.YYYY");
  }

  ngAfterViewInit() {
    this.initExpenseGrid();
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

  initSearchParameters() {

    //Eirik 10.12.19 task 154 - only show these combos of categories and statuses
    let categoryStatusCombos : any[] = [];
    //Eirik 16.08.21 task 854 - show unconfirmed expenses.
    if (!this.showOnlyConfirmed) {
      categoryStatusCombos.push( {
        CategoryId: 1,
        StatusId: 2,
      });
      //Eirik 16.08.21 task 854 - show unconfirmed expenses from transports.
      categoryStatusCombos.push( {
        CategoryId: 7,
        StatusId: 2,
      });
    }
    categoryStatusCombos.push( {
      CategoryId: 9,
      StatusId: 3,
    });
    if (!this.showOnlyConfirmed) {
      categoryStatusCombos.push( {
        CategoryId: 9,
        StatusId: 4,
        ShowEqualOrLargerThanStatus: true,
      });
    }
    categoryStatusCombos.push( {
      CategoryId: 8,
      StatusId: 3,
    });
    if (!this.showOnlyConfirmed) {
      categoryStatusCombos.push( {
        CategoryId: 8,
        StatusId: 4,
        ShowEqualOrLargerThanStatus: true,
      });
    }
    this.searchParameters.EmployeeIds = [];
    this.searchParameters.FromDate = this.from;
    this.searchParameters.ToDate = this.to;
    this.searchParameters.CategoryStatusCombos = categoryStatusCombos;
    this.searchParameters.ProjectIds = this.projectIds != null ? this.projectIds : [];
  }

  initExpenseGrid() {
    this.initSearchParameters();
    if (this.expenseGrid) {
      if (!this.expenseGrid.gridColumns) {
        this.expenseGrid.initExpenseGrid(137, true);
      }
    }
  }

  showDataField(dataFields: any, dataFieldName: string) {
    var visible = false;
    dataFields.forEach(name => {
      if (name === dataFieldName) {
        visible = true;
      }
    });
    return visible;
  }

  loadExpense() {

  }

  dateChangedExpense(dateInterval: any) {


  }



  initGridRecordsSearchParameters(iDateRangeIndex?: number, iSupervisorId?: number, initDate?: any) {

    if (iDateRangeIndex != null) {
      this.selectedDateRangeIndex = iDateRangeIndex;
      this.setSelectedDateRangeIndex = iDateRangeIndex;
    }
    // if (iSupervisorId != null) {
    //   this.selectedSupervisorId = iSupervisorId;
    // }
    // if (initDate) {

      this.from = moment().format("DD.MM.YYYY");
      this.to = moment().format("DD.MM.YYYY");
    // }
  }

  dateChanged(dateInterval: any) {


    this.checkUnsavedChanges().then((doSave:any)=>{

      if (doSave) {
        this.saveEditData();
      }
      else {
        this.cancelEditData();
      }

      if (dateInterval.FromDate !== null) {
        this.from = moment(dateInterval.FromDate).format("DD.MM.YYYY");
      }
      else {
        this.from = "01.01.0001";
      }
      this.to = moment(dateInterval.ToDate).format("DD.MM.YYYY");

      this.initExpenseGrid();
      this.expenseGrid.loadGridRecords(this.searchParameters, false, false);
    });
  }

  saveEditData() {
    this.expenseGrid.saveEditData();
  }

  cancelEditData() {
    this.expenseGrid.cancelEditData();
  }

  selectAll() {
    this.expenseGrid.dxgrid.instance.selectAll();
  }

  deselectAll() {
    this.expenseGrid.dxgrid.instance.deselectAll();
  }

  checkUnsavedChanges(): Promise<boolean> {

    let hasEditData = this.expenseGrid.hasEditData();
    return new Promise(resolve => {
    if (hasEditData) {
          var res = confirm(this.languageService.LNG("Label.Do.You.Want.To.Save.Changes.Before.Continuing",), this.languageService.LNG("Label.Unsaved.Changes"));
          res.then((yes: boolean) => {

            if (yes) {
              resolve(true);
            }
            else {

              resolve(false);
            }
          });
      }
      else {
        resolve(false);
      }
    })
  }

  onRefresh(showLoadIcon = true) {
    this.initSearchParameters();

    if (this.expenseGrid) {
      if (!this.expenseGrid.gridColumns) {
        this.expenseGrid.initExpenseGrid(137, true).then(isOk => {

          if (isOk) {
            this.expenseGrid.loadGridRecords(this.searchParameters, true, showLoadIcon);
          }
        });
      }
      else {
        this.expenseGrid.loadGridRecords(this.searchParameters, true, showLoadIcon);
      }
    }
  }

  getSelectedRows() {
    return this.expenseGrid.dxgrid.instance.getSelectedRowKeys();
  }

  getSelectedRowsData() {
    return this.expenseGrid.dxgrid.instance.getSelectedRowsData();
  }

  onApprove(preventApproveAll: boolean = false): Promise<boolean> {

    this.loading.emit(true);
    return new Promise(resolve => {

      let expenseIds: number[] = [];
      let selectedRowsData = this.expenseGrid.dxgrid.instance.getSelectedRowsData();
      if (selectedRowsData.length == 0 && !preventApproveAll) {
        this.expenseGrid.dataSource.forEach(expense => {

          selectedRowsData.push(expense);
        });
      }

      if (selectedRowsData.length > 0) {
        for (let i = 0; i < selectedRowsData.length; i++) {
            expenseIds.push(selectedRowsData[i].ExpenseId);
        }

        if (expenseIds.length > 0) {
          if (expenseIds.length > 100) {
            let startIndex = 0;
            let endIndex = 100;
            let arrayRequests = [];
            while (endIndex <= expenseIds.length) {
              let expenseIdsSliced = expenseIds.slice(startIndex, endIndex);
              if (expenseIdsSliced.length === 0) {
                break;
              }

              let requestConfirm = this.timeService.approveExpenseByExpenseIds(expenseIdsSliced, this.approvalFunction);
              arrayRequests.push(requestConfirm);
              startIndex = endIndex;
              endIndex = endIndex + 100 > expenseIds.length ? expenseIds.length : endIndex + 100;
              if (startIndex > expenseIds.length) {
                break;
              }
            }
            forkJoin(arrayRequests).subscribe((results: any) => {

              this.loading.emit(false);
              let bAllOk = true;
              for(let result of results){
                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                  bAllOk = false;
                }
              }
              if (bAllOk) {
                let okMessage = this.languageService.LNG("Label.Expenses") + " " + this.languageService.LNG("Label.Is.Approved");
                this.amsNotifierService.success(okMessage);
                this.expenseGrid.dxgrid.selectedRowKeys = [];
              }
              resolve(true);
            });
          }
          else {
            this.timeService.approveExpenseByExpenseIds(expenseIds, this.approvalFunction).subscribe((result: any) => { // success path

              this.loading.emit(false);

              if (result.IsSuccess) {
                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                this.expenseGrid.dxgrid.selectedRowKeys = [];
                let okMessage = this.languageService.LNG("Label.Expenses") + " " + this.languageService.LNG("Label.Is.Approved");
                this.amsNotifierService.success(okMessage);
                resolve(true);
              }
              else {
                this.amsNotifierService.error(result.ErrorMessage);
                resolve(false);
              }
            }, error => { // error path;
              this.loading.emit(false);
              resolve(false);
            });
          }
        }
        else {
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Expense.Posts.To.Approve"));
          this.loading.emit(false);
          resolve(false);
        }
      }
      else {
        resolve(false);
      }
    })
  }

  onReset(statusId): Promise<boolean> {
    this.loading.emit(true);
    return new Promise(resolve => {
      let expenseIds: number[] = [];
      let selectedRowsData = this.expenseGrid.dxgrid.instance.getSelectedRowsData();

      if (selectedRowsData.length > 0) {
        for (let i = 0; i < selectedRowsData.length; i++) {
          expenseIds.push(selectedRowsData[i].ExpenseId);
        }

        if (expenseIds.length > 0) {
          if (expenseIds.length > 100) {
            let startIndex = 0;
            let endIndex = 100;
            let arrayRequests = [];
            while (endIndex <= expenseIds.length) {
              let expenseIdsSliced = expenseIds.slice(startIndex, endIndex);
              if (expenseIdsSliced.length === 0) {
                break;
              }

              let requestReset = this.timeService.resetExpenseByExpenseIds(expenseIdsSliced, statusId, this.approvalFunction);
              arrayRequests.push(requestReset);
              startIndex = endIndex;
              endIndex = endIndex + 100 > expenseIds.length ? expenseIds.length : endIndex + 100;
              if (startIndex > expenseIds.length) {
                break;
              }
            }
            forkJoin(arrayRequests).subscribe((results: any) => {

              this.loading.emit(false);
              let bAllOk = true;
              for(let result of results){
                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                  bAllOk = false;
                }
              }
              if (bAllOk) {
                this.amsNotifierService.success(this.languageService.LNG("Label.Reset.Ok"));
                this.expenseGrid.dxgrid.selectedRowKeys = [];
              }
              resolve(true);
            });
          }
          else {
            this.timeService.resetExpenseByExpenseIds(expenseIds, statusId, this.approvalFunction).subscribe((result: any) => { // success path

              this.loading.emit(false);

              if (result.IsSuccess) {
                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                else {
                  this.expenseGrid.dxgrid.selectedRowKeys = [];
                  this.amsNotifierService.success(this.languageService.LNG("Label.Reset.Ok"));
                }
                resolve(true);
              }
              else {
                this.amsNotifierService.error(result.ErrorMessage);
                resolve(false);
              }
            }, error => {
              this.loading.emit(false);
              resolve(false);
            });
          }
        }
        else {
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Posts.To.Reset"));
          this.loading.emit(false);
          resolve(false);
        }
      }
      else {
        resolve(false);
      }
    });
  }

  onEditingStart(e) {
    this.editingStart.emit(e);
  }

  onCellPrepared(e) {
    this.cellPrepared.emit(e);
  }

  onLoadingDetail(loading: boolean) {

    this.loading.emit(loading);
  }

  onShowExpenseGrid(show: boolean) {

    this.showExpenseGrid.emit(show);
  }

  @Input()
  set projectIdsDataSource(ids: any[]) {

    this.projectIds = ids;
  }

  @Input()
  set setShowTransportColumn(showColumn) {

    if (this.showTransportColumn !== showColumn) {
      this.showTransportColumn = showColumn;
      this.onRefresh();
    }
  }

}
